"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var MaterialIcon_1 = __importDefault(require("../../MaterialIcon"));
var Typography_1 = __importDefault(require("../../Typography"));
var styles_1 = require("./styles");
var MultiSelectedValues = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange;
    var handleRemoveItem = function (removedValue) {
        if (value) {
            onChange(value.filter(function (v) { return v !== removedValue; }));
        }
    };
    if (!value || value.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styles_1.Container, { children: value.map(function (v) {
            var option = options.find(function (o) { return o.value === v; });
            if (!option) {
                return null;
            }
            return ((0, jsx_runtime_1.jsxs)(styles_1.MultiOptionCard, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default.Body, __assign({ size: "sm", "data-testid": "dropdown-selected-option-".concat(v, "-label") }, { children: option.label }), option.value), (0, jsx_runtime_1.jsx)(styles_1.RemoveButton, __assign({ onClick: function () { return handleRemoveItem(v); }, "data-testid": "dropdown-selected-option-".concat(v, "-remove-button") }, { children: (0, jsx_runtime_1.jsx)(MaterialIcon_1.default, { name: "close", size: "s" }) }))] }, option.value));
        }) }));
};
exports.default = MultiSelectedValues;
